///<amd-module name="typeahead/client/OpenSearchPageHandler" />
import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class OpenSearchPageHandler implements IClientHandler {
    private static readonly rfrrIdPrefix: string = "Open.Search|UpdateSearch";
    private static readonly APPLICABLE_CLIENT_ID = "OpenSearchPage";

    public isApplicable(clientId: string): boolean {
        return OpenSearchPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
        $("div.open-search-page").on("click", "button#search-button", () => {
            if ($("#uta-search-query").val()) {
               this.publishSubmitMessages();
            }
        });

        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, message: SuggestionSelectedMessage) => {
                setTimeout(() => {
                    this.publishSubmitMessages();
                }, 0); // Do this after all other selection handlers have executed
            },
        );
    }

    public subscribeFormLoadedEvent(): void {
        // TODO
    }

    public getTab(): string {
        return undefined;
    }

    public getGeolocationViewController(): GeolocationViewController {
        return undefined;
    }

    private publishSubmitMessages(): void {
        ClientHandlerRegistry.publishSubmitClickedMessage(OpenSearchPageHandler.rfrrIdPrefix);
        ClientHandlerRegistry.publishFormSubmittedMessage(true);
    }
}
